import { contextConstant } from "../context/constant";

/**
 * Helper function to open login modal
 * This should be used with dispatch from StateContext
 * @param {Function} dispatch - dispatch function from StateContext
 */
export const openLoginModal = (dispatch) => {
  dispatch({
    type: contextConstant.SET_SHOW_LOGIN_MODAL,
    payload: true,
  });
};
